// Konfigurace všech obrázků na webu
// Vlastní fotky ze složky /fotky

const siteImages = {
  // Logo
  logo: 'https://imagedelivery.net/2OhTeUm5dT07PSQroFepFw/40be5d28-47ca-4830-fcae-0a3ee9e60200/public',

  // Hero slideshow - hlavní stránka (fotky 1-4)
  hero: [
    '/fotky/hero-hlavni.webp',
    '/fotky/hero-obyvak.webp',
    '/fotky/hero-kuchyne.webp',
    '/fotky/hero-detail.webp'
  ],

  // Proces sekce (fotky 5-7)
  process: {
    step1: '/fotky/proces-1.webp',
    step2: '/fotky/proces-2.webp',
    step3: '/fotky/proces-3.webp'
  },

  // Před/Po slider
  beforeAfter: {
    before: 'https://imagedelivery.net/2OhTeUm5dT07PSQroFepFw/f41a5c75-18e8-4848-67e8-48faea371200/public',
    after: 'https://imagedelivery.net/2OhTeUm5dT07PSQroFepFw/fb3bd985-aa87-4574-dc3d-da25df8a4800/public'
  },

  // Hero obrázky pro jednotlivé stránky (mix fotek 1-4)
  pageHeroes: {
    koupit: '/fotky/hero-hlavni.webp',
    prodat: '/fotky/hero-obyvak.webp',
    spoluprace: '/fotky/hero-kuchyne.webp',
    rychlyVykup: '/fotky/hero-detail.webp',
    realizace: '/fotky/hero-hlavni.webp',
    kontakt: '/fotky/hero-obyvak.webp'
  },

  // Pozadí sekce O nás
  aboutBackground: '/fotky/hero-kuchyne.webp',

  // Footer pozadí
  footerBackground: '/fotky/hero-detail.webp',

  // Placeholder pro nemovitosti bez fotky
  propertyPlaceholder: '/fotky/hero-hlavni.webp'
};

export default siteImages;

